/**
 * The Open control on a card (or a card's row) that shows a record: it opens the record inside the conversation, in
 * the records panel (owner 2026-10-31). Renders nothing where the conversation has no panel, or for a type the person
 * cannot open.
 */
import { PanelRightOpen } from 'lucide-react';
import type React from 'react';
import { Button } from '../../ui/Button.js';
import { type EntityPointer, useEntityOpener } from './entity-opener.js';

export const OpenEntityButton: React.FC<{ entityRef: EntityPointer & { title: string } }> = ({ entityRef }) => {
  const opener = useEntityOpener();
  if (!opener?.canOpen(entityRef)) return null;
  return (
    <Button
      variant="ghost"
      size="sm"
      iconOnly
      aria-label={`Open ${entityRef.title}`}
      onClick={(event) => {
        // A row's own press says its message; the Open control only opens the record.
        event.stopPropagation();
        opener.open(entityRef);
      }}
    >
      <PanelRightOpen size={15} aria-hidden />
    </Button>
  );
};
